import React, { useState } from 'react';
import APIResponse from '../../../../../templates/components/APIResponse';
import RecurringPaymentsService from '../../../../../../services/api/recurring-payments.service';
import DimLoader from '../../../../../templates/components/DimLoader';

const PauseRestartPlan = (props) => {
    const [isLoader, setIsLoader] = useState(false);
    const [apiResponse, setApiResponse] = useState();

    const onSuccess = () => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    };

    const handlePause = () => {
        setIsLoader(true);
        RecurringPaymentsService.updateRecurringPayment({ recurringId: props.initialData.id, isPaused: true })
            .then((response) => {
                setApiResponse(response);
            })
            .catch(error => {
                setApiResponse(error);
            })
            .finally(() => {
                setIsLoader(false);
            });
    };

    const handleRestart = () => {
        if (props.onRestart) {
            props.onRestart();
        }
        // if (props.onClose) {
        //     props.onClose();
        // }
    };

    return (
        <>
            {isLoader &&
                <DimLoader loadMessage="Processing..." />}
            <div>
                <div className='col-12'>
                    <div className=" card p-3 bg-faded text-primary b-1">
                        Are you sure you want to {props.isPaused ? 'restart' : 'pause'} this plan?
                    </div>
                </div>
                <div className='col-12 mt-3 d-flex justify-content-between'>
                    <div className='col-auto'>
                        <button className="btn btn-primary" onClick={props.isPaused ? handleRestart : handlePause}>{isLoader ? 'Processing...' : (props.isPaused ? 'Restart' : 'Pause')}</button>
                    </div>
                    <div className='col-auto'>
                        <button className="btn btn-secondary float-right" onClick={e => { e.preventDefault(); if (props.onClose) { props.onClose() } }}>No</button>
                    </div>
                </div>
            </div>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    );
};

export default PauseRestartPlan;